import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { CREST_URL } from "../components/SiteLayout";
import { toast } from "sonner";

const AdminLoginPage = () => {
  const { login } = useAuth();
  const [form, setForm] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (error) {
      const msg = formatApiErrorDetail(error.response?.data?.detail) || error.message;
      setErr(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block hero-bg relative">
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-10">
          <img src={CREST_URL} alt="GODSC" className="h-36 w-auto" />
          <div className="overline text-[#D4AF37] mt-6">Executive Portal</div>
          <h2 className="font-serif-display text-5xl mt-3">Administer the Club.</h2>
          <p className="mt-5 max-w-md text-[#D8D3C4] text-sm leading-relaxed">
            Access the interest pipeline, review submissions, and manage the
            members of the active line.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-20 bg-[#FDFBF7]">
        <div className="w-full max-w-md">
          <Link to="/" className="overline text-[#5C5C5C] hover:text-[#C9A227]" data-testid="back-home">
            &larr; Back to Site
          </Link>
          <h1 className="font-serif-display text-4xl text-[#0A1F44] mt-6">Admin Sign In</h1>
          <div className="h-[2px] w-12 bg-[#D4AF37] mt-4 mb-8" />

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="overline text-[#5C5C5C] block mb-2">Username</label>
              <input
                required
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                className="w-full border border-[#D8D3C4] px-3 py-3 focus:outline-none focus:border-[#D4AF37] focus:ring-2 focus:ring-[#D4AF37]/30 rounded-none text-sm"
                data-testid="admin-username"
              />
            </div>
            <div>
              <label className="overline text-[#5C5C5C] block mb-2">Password</label>
              <input
                required
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full border border-[#D8D3C4] px-3 py-3 focus:outline-none focus:border-[#D4AF37] focus:ring-2 focus:ring-[#D4AF37]/30 rounded-none text-sm"
                data-testid="admin-password"
              />
            </div>
            {err && (
              <div className="border border-red-300 bg-red-50 text-red-800 px-4 py-3 text-sm" data-testid="admin-login-error">
                {err}
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-primary-navy w-full disabled:opacity-60" data-testid="admin-login-submit">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
